import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { TextLoader } from '~/components/Loaders'
import { Icon } from '~/components'
import { TextEdit } from '~/services'


export default class extends React.Component {
    static propTypes = {
		bookmarks: PropTypes.array,
		fetching: PropTypes.bool.isRequired
	};

    render() {

		return (

			<div>

				<h3 className="mtop0 mbot20">Recent Bookmarks</h3>

                { this.props.fetching 
                	? <TextLoader />
                	: this.props.bookmarks.length > 0 
		                ? this.props.bookmarks.slice(0,5).map(item => {
							return <p className="activity-row small" key={'bookmarks-list-'+item.ID}>
								<Icon icon={item.post_type.slug} className={'text-mid-danger mright10'} />
								<Link to={item.link}>{ TextEdit.cutText( item.title, [60, 70] ) } </Link>
							</p>

		                })
		                : <p className="text-center mtop30">You have no bookmarks. <Link to="/">Explore Five to Nine Club</Link></p>
                }	

            </div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/Bookmarks.jsx